module.exports = __webpack_public_path__ + "img/side-icon1.6c4f782f.svg";